const addToken = () =>{
    const token = localStorage.getItem("token");
    const headers = { Authorization: `Bearer ${token}` };
    return {headers}
}

export default addToken;